import React, { useState, useEffect } from 'react';
import './about.css'
import AboutInfo from '../AboutInfo/AboutInfo';
import AboutMain from '../AboutMain/AboutMain';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";

const AboutSection = () => {
    const [aboutDoc, setAboutDoc] = useState(null);
    const HumanHand=`
    .about-container:before {
        background-image: url(${aboutDoc?.human_hand?.url});  
    }
    `
    useEffect(() => {
        client
            .query({
                query: queries.aboutSection,
            })
            .then((response) => {
                const aboutDocContent = response.data.allAbouts.edges[0].node;
             
                setAboutDoc(aboutDocContent);

            })
            .catch((error) => {
                console.error(error);
            });
    });

    
    return (
        <section id="about" style={{ background: `url(${aboutDoc?.about_bg?.url})` }}  className=" pattern  about-container" >
          
          <style>
              {HumanHand}
          </style>
            <div id='about-stepper' className="container">
                <h5 className="section-title"> {aboutDoc?.title[0]?.text}</h5>
                <AboutMain aboutDoc={aboutDoc}></AboutMain>
                <AboutInfo aboutInfo={aboutDoc?.about_info}></AboutInfo>
            </div>
        </section>
    );
};

export default AboutSection;